import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-wechatpay",
  "use": "icon-wechatpay-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-wechatpay\"><defs><style type=\"text/css\"></style></defs><path d=\"M511.9 512h0.2-0.2m0 0h0.2-0.2\" p-id=\"1452\" /><path d=\"M389.9 616.8c-4 2-8.6 3.2-13.4 3.2-11.2 0-20.9-6.2-26-15.3l-2-4.3-81.6-179c-0.9-2-1.4-4.2-1.4-6.3 0-8.3 6.7-14.9 14.9-14.9 3.4 0 6.4 1.1 8.9 3l96.2 68.5c7.3 4.8 15.8 7.3 24.5 7.3 5.4 0 10.5-1 15.3-2.7l452.6-201.4C796.8 179.2 663.2 116.7 512 116.7 264.6 116.7 64 283.8 64 490c0 112.5 60.3 213.8 154.8 282.2 7.6 5.4 12.5 14.3 12.5 24.3 0 3.3-0.7 6.4-1.6 9.5-7.5 28.2-19.6 73.2-20.2 75.3-0.9 3.5-2.4 7.2-2.4 10.9 0 8.2 6.7 14.9 14.9 14.9 3.2 0 5.9-1.2 8.6-2.8l98.1-56.6c7.4-4.3 15.2-6.9 23.8-6.9 4.6 0 9 0.7 13.2 2 45.8 13.2 95.1 20.5 146.2 20.5 247.4 0 448-167.2 448-373.3 0-62.4-18.5-121.3-51-173L393.1 614.9l-3.2 1.9z\" p-id=\"1453\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/wechatpay.svg
// module id = hTY/
// module chunks = 31